import { Injectable } from '@angular/core';
import { HeightImageService } from '@design/services/height-image-data.service';
import { Store } from '@ngrx/store';
import { fromAdditionalToolsActions } from '@design/store/additional-tools';
import { SaveStatus } from '@design/models/save-status.model';
import { DesignState } from '@design/store/design.reducer';
import { QuoteApiRequest } from '@api/models/quote.model';
import { AuthService, DesignOnlyState } from 'src/app/helpers/auth.service';
import { SystemDesignService } from '../../system-design/system-design.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isSuccess } from 'src/app/models/simple.types';
import { ProjectWorkflowService } from '../../projects/project-workflow/project-workflow.service';
import { ProjectsService } from '../../projects/projects.service';
import { GoogleMapsLoaderService } from '../../../services/google-maps-loader.service';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserPreferenceService } from '@api/services/user-preference.service';
import { MapType } from '@design/models/ui-state.model';

@Injectable({
  providedIn: 'root'
})

export class LoginDesignService {
  consumer: any;
  financeEnabled: boolean | undefined = undefined;
  designStorageState = DesignOnlyState.STARTED;

  constructor(
    public heightImageService: HeightImageService,
    private store: Store<DesignState>,
    private authService: AuthService,
    private systemDesignService: SystemDesignService,
    public projectWorkflowService: ProjectWorkflowService,
    private projectsService: ProjectsService,
    public router: Router,
    private http: HttpClient,
    private userPreferenceService: UserPreferenceService,
    private googleMapsLoader: GoogleMapsLoaderService
  ) {

  }
  
  // loginToDesign(params: any): void {
  //   this.loadLeadInfo(params.crn).then((res) => {
  //     this.consumer = res.data;
  //     this.authService.setItem('crn', params.crn);
  //     this.authService.setItem('design_only', 'qkshodgh');
  //     this.authService.setItem('totalMeters', +res?.data?.c_number_meter);
  //     this.getSystemDesign(this.consumer);
  //   });
  // }


  loginToDesign(params: any): void {
    this.projectWorkflowService.getLeadInfo(params.crn).pipe(take(1)).subscribe((res) => {
      this.consumer = res.data;
      this.authService.setItem('crn', params.crn);
      this.authService.setItem('design_only', 'qkshodgh');
      this.authService.setItem('totalMeters', +res?.data?.c_number_meter);
      this.getSystemDesign(this.consumer);
    },
      (error) => {
        console.error('Failed to load lead info:', error);
        // Optionally handle error, show notification, etc.
      }
    );
  }

  validateExternalLoginParams(params: any): Promise<any> {
    let key = params?.access_key;
    let account_id = params?.account_id;
    let crn = params?.crn;
    let redirect_url = params?.redirect_url;
    if (!key || !account_id || !crn || !redirect_url) {
      return Promise.resolve("InvalidData");
    }

    return this.authenticate(key, account_id).then((data) => {
      if ('email_id' in data) {
        this.authService.setItem('backToCrmUrl', redirect_url);
        return data;
      }
      return 'Unauthorized';
    });
  }

  getSystemDesign(consumer: any): void {
    let defaultMapOption = ('defaultMapOption' in consumer) ? consumer['defaultMapOption'] : MapType.GOOGLESOLAR;
    let checkHasDSM = (('hasDSM' in consumer) ? consumer['hasDSM'] : true).toString();
    let designQuote = ('datQuote' in consumer) ? consumer['datQuote'] : '';
    let mode = (designQuote === '') ? 'create' : 'edit';

    const payload: QuoteApiRequest = {
      crn: this.consumer?.crn,
      quoteType: this.consumer?.type,
      accountId: this.authService.getItem('account_id')
    };

    if (mode == 'create') {
      this.store.dispatch(fromAdditionalToolsActions.setMapLoadingStatus({ mapLoadingStatus: SaveStatus.OUTDATED }));
      this.heightImageService.checkHeightDataStatus(defaultMapOption, checkHasDSM);
      this.systemDesignService.createQuoteV2(payload, new HttpHeaders()).pipe(take(1)).subscribe((res) => {
        if (isSuccess(res.status) && Object.keys(res?.data).length) {
          const qrn = res?.data?.['qrn'];
          this.systemDesignService.changeActivePage('create');
          this.authService.setItem('qrn', qrn);
          this.authService.setItem('quote_id', res?.data?.['quoteId']);
          this.authService.setItem('revision_number', res?.data?.['revisionNumber']);
          this.authService.setItem('quote_status', res?.data?.['quoteStatus']);

          let reqBodyConsumer = { 'datQuote': qrn, crn: consumer.crn };
          this.http.put(`${environment.newApiUrl}lead`, reqBodyConsumer).pipe(take(1))
            .subscribe((resp: any) => {
              this.loadSystemDesign();
            });
        } else {
          //this.toastr.error(res.error);
        }
      }, (error) => {
        // handle error if needed
      });
    } else {
      this.authService.setItem('qrn', designQuote);
      this.http.get(`${environment.newQuoteAPIEndpoint}quote/getQuoteByQrn/${designQuote}`).pipe(take(1))
        .subscribe(
          (response: any) => {
            this.systemDesignService.changeActivePage('edit');
            this.authService.setItem('qrn', response.qrn);
            this.authService.setItem('quote_id', response.quoteId);
            this.authService.setItem('revision_number', response.revisionNumber);
            this.authService.setItem('quote_lat', consumer?.latitude);
            this.authService.setItem('quote_long', consumer?.longitude);
            this.authService.setItem('quote_status', response['quote_status']);
            this.loadSystemDesign();
          },
          (error: any) => {
            // handle error if needed
          }
        );
    }
  }
  
  loadSystemDesign() {
    const that = this;
    if (this.consumer.latitude != undefined && this.consumer.longitude != undefined) {
      this.authService.setItem("c_lat", this.consumer.latitude);
      this.authService.setItem("c_long", this.consumer.longitude);
      this.authService.setItem("quote_lat", this.consumer.latitude);
      this.authService.setItem("quote_long", this.consumer.longitude);
      if (!!this.consumer.defaultMapOption) {
        this.authService.isActiveTabSub$.next(0); // On edit quote click setting design tab enable in design page
        this.router.navigate(['/design']);
      } else {
        this.router.navigate(['/systemdesign']);
      }
    } else {

      const address = this.consumer.address + ", " + this.consumer.zip_code;
      this.googleMapsLoader.loadGoogleMaps().subscribe({
        next: () => {
          let geocoder: any = new google.maps.Geocoder;
          let that = this;
          geocoder.geocode({ 'address': address }, function (results: any, status: any) {
            if (results[0]) {
              //do not REMOVE c_lat and c_long. Its being used in PVwatts for design
              that.authService.setItem("c_lat", results[0].geometry.location.lat());
              that.authService.setItem("c_long", results[0].geometry.location.lng());
              that.authService.setItem("quote_lat", results[0].geometry.location.lat());
              that.authService.setItem("quote_long", results[0].geometry.location.lng());
              if (!!that.consumer.defaultMapOption) {
                that.authService.isActiveTabSub$.next(0); // On edit quote click setting design tab enable in design page
                that.router.navigate(['/design']);
              } else {
                that.router.navigate(['/systemdesign']);
              }
            } else {
            }
          });
        },
        error: (error: any) => {
          console.error('Failed to load Google Maps API:', error);
          // Handle error gracefully - maybe navigate to system design anyway or show an error
          if (!!this.consumer.defaultMapOption) {
            this.authService.isActiveTabSub$.next(0);
            this.router.navigate(['/design']);
          } else {
            this.router.navigate(['/systemdesign']);
          }
        }
      });
    }
  }

  getCsrfToken(): Promise<any> {
    let url = `${environment.authApiUrl}/csrf-token/`
    let csrfResponse = this.http.get(url, { observe: 'response', withCredentials: true });
    return csrfResponse.toPromise()
  }

  authenticateKey(csrfToken: string, requestBody: any): Promise<any> {
    let url = `${environment.authApiUrl}/authenticate-key/`
    const headers = new HttpHeaders({
      'X-CSRFToken': csrfToken,
      'content-type': 'application/json'
    });
    let res = this.http.post(url, requestBody, { headers: headers, withCredentials: true });
    return res.toPromise()
  }

  async authenticate(access_key: string, account_id: string): Promise<any> {

    let res = await this.getCsrfToken()

    let requestBody = {
      "access_key": access_key,
      "account_id": account_id
    }

    let token = res.headers.get('CSRF-TOKEN') as string

    try {
      let responseAuth = await this.authenticateKey(token, requestBody);
      return responseAuth
    } catch (err) {
      return err;
    }
  }

  triggerWebhook(): Observable<any> {
    const apiUrl = `${environment.webhookApi}trigger/`;
    const crn = this.authService.getItem('crn');
    const quoteId = this.authService.getItem('quote_id');
    const revisionNumber = this.authService.getItem('revision_number');
    const account = this.authService.getItem('account_id');
    let payload = {
      "eventType": "design.created",
      "eventTime": Date.now(),
      "accountId": account,
      "data": {"quoteId": quoteId, "crn": crn, "revisionNumber": revisionNumber}
    }
    let options = {
      headers: new HttpHeaders({
        'x-api-key': environment.webHookClientKey
      }),
    };
    return this.executeObservableWithTimeout(this.http.post(apiUrl, payload, options), 3000);
  }

  backToCrm(storageType: string = 'default'): void {
    let crmUrl = this.authService.getItem("backToCrmUrl");
    this.triggerWebhook().subscribe({
      next: (webhookResult) => {
        console.log(webhookResult);
        this.authService.clearEverything();
        window.location.href = crmUrl;
      },
      error: (error) => {
        console.log('Webhook not triggered');
        this.authService.clearEverything();
        window.location.href = crmUrl;
      }
    });
  }

  executeObservableWithTimeout(toExecute: Observable<any>, timeoutMs: number): Observable<any> {
    return toExecute.pipe(
      timeout(timeoutMs),
      catchError((err) => {
        if (err.name === 'TimeoutError') {
          return of({ error: 'Timeout occurred' });
        }
        return of({ error: err });
      })
    );
  }

  isFinanceEnabled() {
    if (this.financeEnabled === undefined) {
      const params = {
        account_id: this.authService.getItem('account_id'),
        email_id: this.authService.getItem('email_id'),
        role: this.authService.getItem('role')
      };
      return this.userPreferenceService.getUserPreference(params).pipe(
        take(1),
        switchMap((data: any) => {
          try {
            if (data.preferencesObj.login_to_design?.finance?.enabled) {
              this.financeEnabled = true;
            } else {
              this.financeEnabled = false;
            }
          } catch (e) {
            this.financeEnabled = false;
          }
          return of(this.financeEnabled);
        }),
        catchError(() => {
          this.financeEnabled = false;
          return of(this.financeEnabled);
        })
      );
    } else {
      return of(this.financeEnabled);
    }
  }

  isLoggedInToDesign() {
    let locValue = this.authService.getItem('design_only');
    if (this.authService.isLoggedIn() && locValue == null) {
      this.designStorageState = DesignOnlyState.MANIPULATED;
      return undefined;
    }
    if (this.designStorageState == DesignOnlyState.IN_PROGRESS) {
      if (locValue == null) {
        this.designStorageState = DesignOnlyState.MANIPULATED;
        return undefined;
      }
    }
    if (this.designStorageState == DesignOnlyState.STARTED) {
      if (locValue != null) {
        this.designStorageState = DesignOnlyState.MANIPULATED;
      }
      return false;
    }

    if (locValue == 'qkshodgh') {
      return true;
    } else if (locValue == 'dshytocm') {
      return false;
    } else {
      this.designStorageState = DesignOnlyState.MANIPULATED;
      return undefined
    }
  }
  
}
 